import {
  GET_DIET_FOOD_TYPES,
  convertResult,
} from 'app/common/api/requests/food/diet_food_types/get'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import {
  DietFoodType,
} from 'app/dataTypes/org/dietFoodTypes'

const defaultState: Array<DietFoodType> = []

type Op = CommonDataOptions<Array<DietFoodType>, void>

export function useDietFoodTypes(options: Op = {} as Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_DIET_FOOD_TYPES,
    error: 'Не удалось получить список видов диетического питания',
    convertions: {
      convertResult,
    },
    defaultState,
  })

  return res
}
